import { render, staticRenderFns } from "./QuestionDisplayRoute.vue?vue&type=template&id=628bb396&scoped=true&"
import script from "./QuestionDisplayRoute.vue?vue&type=script&lang=js&"
export * from "./QuestionDisplayRoute.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDisplayRoute.vue?vue&type=style&index=0&id=628bb396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628bb396",
  null
  
)

export default component.exports